import React, { Component } from 'react';
import { postsSelectorWithList, getPosts } from '../../ducks/posts';
import { userSelector } from '../../ducks/users';
import { connect } from 'react-redux';
import get from 'lodash/get'
import PageList from '../../components/organism/page-list';
import CssIcon from "../../components/atom/CssIcon";
import "simplemde/dist/simplemde.min.css";

const mapStateToProps = (store, { match: { params } }) => {
  const page = get(params, 'page', undefined);
  return {
    me: !!store.users.me,
    posts: postsSelectorWithList(store, 'games', page),
    profile: userSelector(store, get(store, ['users', 'me'])),
  };
};

class Games extends Component {
  componentDidMount() {
    const { dispatch, match } = this.props;
    const page = get(match, ['params', 'page'], undefined);
    dispatch(getPosts('games', page));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      get(this.props.match, ['params', 'page']) !==
      get(nextProps.match, ['params', 'page'])
    ) {
      const page = get(nextProps.match, ['params', 'page'], undefined);
      this.props.dispatch(getPosts('games', page));
    }
  }

  render() {
    return (
      <div className="Games-page Page-list-width">
        <div className="Page-list-header">
          <h1>
            <CssIcon type="play" color="pink" width="36" height="36" />
            Spel
          </h1>
          <p>
            Här pratar vi om allt som rör spel. Senaste nytt, skvaller, rykten,
            HYPE, kärleksförklaringar, åsikter och mer därtill. Låt konsolkriget
            vara förpassat till historien och visa respekt.
          </p>
        </div>
        <PageList {...this.props} whatCategory="games" pagePath="spel" />
      </div>
    );
  }
}

export default connect(mapStateToProps)(Games);
